module.exports = __webpack_public_path__ + "img/FGr_Logistik.9a3c14f7.svg";